import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { content } from '../data';
import { Menu, X, Facebook } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className="fixed w-full z-50 bg-[#04a6df] shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Row 1: Logo & Mobile Toggle */}
        <div className="flex justify-between items-center py-4">
          <div className="flex-shrink-0">
            <Link to="/" className="block">
              <img 
                src={content.images.logo} 
                alt="Logo" 
                className="h-14 md:h-16 lg:h-20 w-auto max-w-[180px] sm:max-w-none object-contain"
              />
            </Link>
          </div>

          {/* Mobile Button & Toggle */}
          <div className="md:hidden flex items-center space-x-4">
            <Link 
              to="/tilmeld" 
              className="bg-[#034b89] hover:bg-[#023a6d] text-white px-5 py-2.5 rounded-full text-sm font-bold uppercase tracking-wider shadow-md"
            >
              Tilmeld
            </Link>

            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white p-2 focus:outline-none"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Row 2: Navigation & CTA (Tablet & Desktop) */}
        <div className="hidden md:flex items-center justify-between pb-6 border-t border-white/10 pt-4">
          <div className="flex items-center space-x-6 lg:space-x-10">
            {content.navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href.startsWith('#') ? `/${item.href}` : item.href}
                className="text-white hover:text-white/80 py-1 text-[10px] lg:text-xs font-semibold uppercase tracking-widest transition-colors whitespace-nowrap"
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center space-x-6 lg:space-x-8">
            <Link 
              to="/tilmeld" 
              className="bg-[#034b89] hover:bg-[#023a6d] text-white px-6 py-2.5 rounded-full text-[10px] lg:text-xs font-semibold uppercase tracking-wider transition-all transform hover:scale-105 shadow-lg whitespace-nowrap"
            >
              Tilmeld dig
            </Link>
            <a 
              href={content.contact.facebook} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white hover:text-white/80 transition-colors"
            >
              <Facebook size={20} />
            </a>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="md:hidden bg-[#04a6df] border-t border-white/10 overflow-y-auto max-h-[calc(100vh-6rem)]">
          <div className="px-2 pt-2 pb-6 space-y-1 sm:px-3">
            {content.navigation.map((item) => (
              <div key={item.name} className="border-b border-white/5 last:border-0">
                <Link
                  to={item.href.startsWith('#') ? `/${item.href}` : item.href}
                  className="text-white block px-3 py-4 text-base font-semibold uppercase tracking-wider hover:bg-[#038bbd]"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
